import * as React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/SamsungPayMobileBox.module.css';
import classNames from 'classnames/bind';
import {useEffect, useRef, useState} from 'react';
import MobileCloseButton from '../buttons/MobileCloseButton';

const cx = classNames.bind(styles);
const imgPath = process.env.REACT_APP_S3_IMG_PATH;

export default function SamsungPayMobileBox(props) {
  SamsungPayMobileBox.propTypes = {
    children: PropTypes.array,
    closeButtonFunction: PropTypes.func,
    mobilePageType: PropTypes.string
  };

  const contentRef = useRef();
  const [contentHeight, setContentHeight] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      const screenH = window.innerHeight;
      if (contentHeight !== screenH) {
        setContentHeight(screenH);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (contentHeight !== null && contentRef.current) {
      contentRef.current.style.height = `${contentHeight}px`;
    }
  }, [contentHeight]);

  return (
    <>
      <div ref={contentRef} className={cx('mpi-contentsbox', 'has-notopview')}>
        <div className={cx('certification')}>
          <div className={cx('bottom-sheet', `${props.mobilePageType}`)}>
            <MobileCloseButton onClose={props.closeButtonFunction}/>
            <picture>
              <source srcSet={`${imgPath}/Dialog_SamsungPay.png`} media="(prefers-color-scheme: light)"/>
              <source srcSet={`${imgPath}/Dialog_SamsungPay_dark.png`} media="(prefers-color-scheme: dark)"/>
              <img src={`${imgPath}/Dialog_SamsungPay.png`} className={cx('logo')}/>
            </picture>
            {props.children}
          </div>
        </div>
      </div>
    </>
  );
}